import _classCallCheck from '../../../../../node_modules/@babel/runtime/helpers/classCallCheck.es.js';
import _createClass from '../../../../../node_modules/@babel/runtime/helpers/createClass.es.js';
import _inherits from '../../../../../node_modules/@babel/runtime/helpers/inherits.es.js';
import _possibleConstructorReturn from '../../../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.es.js';
import _getPrototypeOf from '../../../../../node_modules/@babel/runtime/helpers/getPrototypeOf.es.js';
import React from 'react';
import { Field } from '../Field/Field.es.js';
import { Checkbox } from './Checkbox.es.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Renders a <CheckboxField /> component
 * @param {string} id - an optional param - set the id on the component
 * @param {boolean} value - set the value on the component
 * @param {boolean} disabled - set the disabled property on the component
 * @param {string} labelPlacement - describes the field label (and description) placement
 * @param {object} labelSize - an optional param - field label text size
 * @param {string | JSX.Element} label - an optional param - field label
 * @param {string} description - an optional param - field description
 * @param {any} onChange - an optional param - add the event listener
 * @param {React.ReactNode | React.ReactNodeArray} labelInfo - an optional param - label info
 **/

var CheckboxField = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CheckboxField, _React$PureComponent);

  var _super = _createSuper(CheckboxField);

  function CheckboxField() {
    var _this;

    _classCallCheck(this, CheckboxField);

    _this = _super.apply(this, arguments);

    _this.handleFieldClick = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          disabled = _this$props.disabled;

      if (onChange && !disabled) {
        onChange(!value);
      }
    };

    return _this;
  }

  _createClass(CheckboxField, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          label = _this$props2.label,
          labelSize = _this$props2.labelSize,
          description = _this$props2.description,
          id = _this$props2.id,
          disabled = _this$props2.disabled,
          labelPlacement = _this$props2.labelPlacement,
          labelInfo = _this$props2.labelInfo;
      return /*#__PURE__*/React.createElement(Field, {
        label: label,
        labelInfo: labelInfo,
        labelSize: labelSize,
        description: description,
        labelPlacement: labelPlacement,
        id: id,
        className: "CheckboxFocusableContainer",
        role: disabled ? 'presentation' : 'checkbox',
        focusable: !disabled,
        "aria-checked": !disabled ? !!value : undefined,
        onClick: this.handleFieldClick,
        "data-testid": 'CheckboxField'
      }, /*#__PURE__*/React.createElement(Checkbox, {
        checked: !!value,
        disabled: !!disabled
      }));
    }
  }]);

  return CheckboxField;
}(React.PureComponent);
CheckboxField.defaultProps = {
  value: false,
  disabled: false,
  labelPlacement: 'left'
};

export { CheckboxField };
